export const secrets = {
  salt: '3Pfg^cA2tv&A3FD%yA2t4nCE%&63w1lp'
}